import { Route } from 'react-router-dom';

import { NotificationTemplateDetailPage } from './pages/notification-template-detail-page.js';
import { NotificationTemplateFormPage } from './pages/notification-template-form-page.js';
import { NotificationTemplateListPage } from './pages/notification-template-list-page.js';

/**
 * Notification template routes.
 *
 * The static /new route is listed before the /:templateId parameter route so a
 * reader does not have to know React Router's ranking to see which one wins.
 */
export function notificationTemplateRoutes(): React.JSX.Element {
  return (
    <>
      <Route path="/notification-templates" element={<NotificationTemplateListPage />} />
      <Route path="/notification-templates/new" element={<NotificationTemplateFormPage />} />
      <Route
        path="/notification-templates/:templateId/edit"
        element={<NotificationTemplateFormPage />}
      />
      <Route
        path="/notification-templates/:templateId"
        element={<NotificationTemplateDetailPage />}
      />
    </>
  );
}
